<script setup>
import { ref } from "vue";
const name = "ButtonRow";
defineProps({
  align: {
    type: String,
    default: "center",
  },
});
const aligment = ref({
  center: "justify-center",
  start: "justify-start",
  end: "justify-end",
});
</script>
<template>
  <div :class="[aligment[align]]" class="flex gap-4 mt-4 w-full items-center">
    <slot />
  </div>
</template>
